import React from 'react'
import { Link } from 'react-router-dom'
import ImageWithFallback from '../common/ImageWithFallback'
import { pluralize } from '../../utils/string.util'
import DisplayBidStatus from '../common/DisplayBidStatus'

const ProductBiddingListItem = ({ bid }) => {
  const renderRequestedQuantity = () => {
    if (!bid?.requestQuantity) return null
    return (
      <p className="text-sm text-gray-500">
        <span className="font-semibold text-gray">{bid.requestQuantity}</span> Request quantity
      </p>
    )
  }

  return (
    <Link
      to={
        bid.productFinderId ? `/product-finder/responses/${bid.productFinderId}` : `/bids/${bid.id}`
      }
      className="block"
    >
      <div className="flex p-3 border border-[rgba(157,87,0,0.3)] rounded-md bg-background hover:shadow-md transition-shadow duration-200">
        <div className="w-[75px] h-[75px] flex-shrink-0 mr-4">
          <ImageWithFallback
            src={bid.imageUrl || '/placeholder-image.png'}
            alt={bid.productName}
            className="w-full h-full object-cover rounded"
          />
        </div>
        <div className="flex flex-col justify-center flex-grow min-w-0">
          <h3 className="text-base font-semibold text-gray-900 truncate">{bid.productName}</h3>
          {renderRequestedQuantity()}
          <div>
            <DisplayBidStatus isOpen={bid.isOpen} expiresAt={bid.expiresAt} />
          </div>
          <p className="text-base font-bold mt-1 text-tertiary-600">
            ({bid.responseCount || 0}) New {pluralize(bid.responseCount, 'Response', 'Responses')}
          </p>
        </div>
      </div>
    </Link>
  )
}

export default ProductBiddingListItem
